import React from 'react';
import ReactDOM from 'react-dom/client';
import {createStore, combineReducers, applyMiddleware} from "redux";
import thunkMiddleware from "redux-thunk";
import {createLogger} from "redux-logger";
import { requestUsers,requestTopUsers,getNumberFollowers,getCustomize,getFontSize,getColorButton,getColorBackground,getRoom,getSecondUser,getRoomMessages,getSectionTitle,getUser,getHomePosts,setDialogTweetShow,setDialogCustomizeShow,setBackButtonShow,setRoomsSecondUserIdArray,editBirthday,editDescription,editFirstName,editLastName,editUserName } from './redux/reducers/reducers';
import {Provider} from "react-redux";
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

// const logger = createLogger();

const rootReducer = combineReducers({ requestUsers,requestTopUsers,getNumberFollowers,getCustomize,getFontSize,getColorButton,getColorBackground,getRoom,getSecondUser,getRoomMessages,getSectionTitle,getUser,getHomePosts,setDialogTweetShow,setDialogCustomizeShow,setBackButtonShow,setRoomsSecondUserIdArray,editBirthday,editDescription,editFirstName,editLastName,editUserName },)
const store = createStore(rootReducer,applyMiddleware(thunkMiddleware));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store} >
      <App />
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
